{
  "fr": {
    "pupilFeedback": {
      "deprecationAlert": {
        "title": "Cet outil est masqué par défaut",
        "description": "Il peut être activé au niveau de l'école sur demande.",
        "learnMoreLink": "En savoir plus"
      },
      "unlockedAlert": {
        "title": "Cet outil est activé pour votre école",
        "description": "Il n'est plus développé, mais reste utilisable pour votre école.",
        "learnMoreLink": "En savoir plus"
      },
      "alerts": {
        "example": "À quoi cela peut-il ressembler ?",
        "exampleButton": "Insérer un exemple de tâche et de critères",
        "noFeedbackYet": "Aucun feedback n'a pu être généré. Veuillez vérifier vos entrées et réessayer.",
        "pupilFeedback": "<strong>Remarque :</strong> Le feedback est généré automatiquement par une IA sur la base des critères prédéfinis et peut contenir des erreurs. En cas de questions ou d'incertitudes, veuillez contacter votre enseignant·e.",
        "pupilFeedbackStudent": "<strong>Remarque :</strong> Le feedback est créé à l'aide de l'IA et repose sur les tâches, matériaux et critères définis par votre enseignant·e. En cas de questions ou d'incertitudes, veuillez contacter votre enseignant·e.",
        "submitting": "Votre feedback est en cours de création.",
        "submittingDescription": "Veuillez patienter un moment."
      },
      "example": {
        "criteriaAttributes": {
          "0": "L'histoire suit une structure narrative logique avec un titre, une introduction, un milieu et une conclusion. Les événements s'enchaînent et mènent à une fin brève, le titre correspondant au thème de l'histoire.",
          "1": "L'histoire utilise des moyens linguistiques pour être captivante. Vous utilisez des mots descriptifs (comme 'effrayant', 'sinistre', 'sombre') et décrivez précisément ce que les personnages voient, entendent et ressentent.",
          "2": "La grammaire et l'orthographe de l'histoire sont correctes. Vous faites attention aux structures de phrases correctes, aux temps verbaux et à l'orthographe, de sorte que le texte soit fluide à lire.",
          "3": "L'histoire contient des débuts de phrases variés."
        },
        "description": "Lisez l'article de journal “Nuit dans la tourbière”. Écrivez une histoire effrayante basée sur les événements. Faites attention aux critères de conception pour rendre votre histoire aussi captivante que possible.",
        "material": "<strong>Article de journal</strong><br>CARLSFELD. Une nuit effrayante dans une tourbière près de Carlsfeld a été vécue par un père avec ses enfants. Après une panne de vélo, M. T. a essayé de rentrer à pied avec Maria (12 ans) et Tom (10 ans). Cependant, dans le froid et le brouillard, ils se sont perdus dans la tourbière. Une opération de recherche de grande envergure déclenchée par la mère inquiète n'a abouti qu'au matin : les chiens pisteurs de la police ont trouvé les trois complètement gelés.",
        "name": "Histoire effrayante"
      },
      "flash": {
        "textExtractionSuccess": "Extraction de texte réussie"
      },
      "headings": {
        "criteria": "Critère",
        "form": "Définir la tâche et les critères"
      },
      "hints": {
        "experimental": "L'outil de feedback pour les élèves crée un <strong>feedback généré par l'IA</strong> basé sur la tâche, les matériaux et les critères fournis par les enseignants. Pour interpréter le feedback de manière responsable, il est impératif de prendre connaissance et de respecter les <strong>conditions et limitations recommandées de l'IA</strong>. <a href='https://app.fobizz.com/de/help/articles/251-feedback-tool-ki' target='_blank'>En savoir plus</a>",
        "noSubmission": "Pas encore soumis",
        "submitSuccessful": "Merci ! Vous avez soumis votre tâche avec succès.",
        "submitSuccessfulShort": "Tâche soumise avec succès"
      },
      "infoMessages": {
        "criteria": "Définissez des critères sur lesquels l'IA doit se baser pour donner un feedback. Plus vous formulez précisément les critères, plus le feedback sera précis.",
        "criterion": "Au moins un critère nécessaire"
      },
      "labels": {
        "allResponses": "Toutes les réponses",
        "answer": "Réponse",
        "assignment": "Consigne de travail",
        "assignmentTitle": "Titre de la tâche",
        "averageScore": "Évaluation globale :",
        "criteria": "Critères de feedback",
        "criteriaVisibleForPupils": "Visible pour les élèves",
        "difference": "Différences par rapport à la 1ère version",
        "draftsAndSubmissions": "Brouillons et soumissions",
        "editFeedback": "Modifier la réponse",
        "emptySubmission": {
          "description": "Partagez la tâche avec vos élèves. Dès qu'ils obtiennent leur premier feedback, vous verrez ici la progression.",
          "title": "Aucun brouillon ou soumission n'est encore disponible pour cette tâche."
        },
        "feedback": "Feedback",
        "finalSubmission": "Soumission | Soumissions",
        "finalSubmit": "Soumettre la tâche",
        "firstSubmission": "1ère version | 1ères versions",
        "material": "Matériel",
        "materialVisibleForPupils": "Visible pour les élèves",
        "noScoreYet": "Évaluation encore ouverte",
        "of": "sur {count}",
        "score": "Évaluation",
        "submit": "Donne-moi un feedback"
      },
      "links": {
        "imageRecognition": "Utiliser le texte de l'image",
        "textExtraction": "Utiliser le texte du PDF",
        "toggleFeedbackDetails": "Afficher le feedback"
      },
      "modals": {
        "confirm": {
          "helpLink": "https://app.fobizz.com/de/help/articles/251-feedback-tool-ki",
          "text": "L'outil de feedback pour les élèves crée un feedback généré par l'IA basé sur la tâche, les matériaux et les critères fournis par les enseignants. Pour interpréter le feedback de manière responsable, il est impératif de prendre connaissance et de respecter les conditions et limitations recommandées de l'IA.",
          "title": "Instructions pour l'utilisation des outils de feedback"
        }
      },
      "placeholders": {
        "answer": "Entrez votre réponse ici...",
        "assignment": "Entrez la consigne de travail ici...",
        "assignmentTitle": "Entrez le nom de la tâche...",
        "criterion": "Entrez le critère...",
        "language": "Langue pour le feedback de l'IA",
        "material": "Ajoutez ici des aides ou du matériel supplémentaire pour la réalisation de la tâche."
      },
      "responseItem": {
        "confirmDelete": {
          "confirm": "Supprimer",
          "text": "Cette action est irréversible. La réponse sera définitivement supprimée.",
          "title": "Supprimer la réponse ?"
        },
        "delete": "Supprimer la réponse",
        "firstFeedback": "1ère version",
        "share": "Copier le lien d'accès",
        "submission": "Soumission"
      },
      "simpleLanguage": {
        "loading": "Veuillez patienter...",
        "translate": "Afficher le feedback en langage simplifié"
      }
    },
    "pupil_feedback": {
      "anonymous": "Anonyme"
    }
  }
}
